import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Layout } from '../layouts/Layout';
import { UlasanGoogleHalaman } from '../componen/UlasanGoogleHalaman';

export const UlasanGoogleHalamanPages = () => {
  const navigate = useNavigate();
  const { isError } = useSelector((state) => state.auth);

  useEffect(() => {
    if (isError) navigate('/', { replace: true });
  }, [isError, navigate]);

  return (
    <Layout>
      <UlasanGoogleHalaman />
    </Layout>
  );
};
